export const ActionTypes = {
  ADD_ROLE_ACTION_LIST: 'ADD_ROLE_ACTION_LIST',
  ADD_ROLE_ACTION: 'ADD_ROLE_ACTION',
  DELETE_ROLE_ACTION: 'DELETE_ROLE_ACTION',

  ADD_USER: 'ADD_USER',
  DELETE_USER: 'DELETE_USER',
  ADD_USER_LIST: 'ADD_USER_LIST',

  ADD_LOGIN_ATTEMPT_LIST: 'ADD_LOGIN_ATTEMPT_LIST',

  ADD_HOST_INFO: 'ADD_HOST_INFO',
  DELETE_HOST_INFO: 'DELETE_HOST_INFO',
  ADD_HOST_INFO_LIST: 'ADD_HOST_INFO_LIST',
  START_GETTING_HOST_INFO_LIST: 'START_GETTING_HOST_INFO_LIST',
  FINISH_GETTING_HOST_INFO_LIST: 'FINISH_GETTING_HOST_INFO_LIST',
  ERROR_GETTING_HOST_INFO_LIST: 'ERROR_GETTING_HOST_INFO_LIST',

  UPDATE_PROFILE: 'UPDATE_PROFILE',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_SUCCESS_WITH_TOKEN: 'LOGIN_WITH_TOKEN',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',

  // KVS - KioskVersionSet for kiosk update
  ADD_KVS: 'ADD_KVS',
  DELETE_KVS: 'DELETE_KVS',
  ADD_KVS_LIST: 'ADD_KVS_LIST',
  ADD_KVS_HISTORY_LIST: 'ADD_KVS_HISTORY_LIST',

  ADD_APP_INFO: 'ADD_APP_INFO',
  DELETE_APP_INFO: 'DELETE_APP_INFO',
  ADD_APP_INFO_LIST: 'ADD_APP_INFO_LIST',

  ADD_LOG_URL: 'ADD_LOG_URL',
  DELETE_LOG_URL: 'DELETE_LOG_URL',
  ADD_LOG_URL_LIST: 'ADD_LOG_URL_LIST',

  SELECT_HOSTINFO_ID: 'SELECT_HOSTINFO_ID',
  SELECT_HOSTINFO_ID_LIST: 'SELECT_HOSTINFO_ID_LIST',
  UNSELECT_HOSTINFO_ID: 'UNSELECT_HOSTINFO_ID',
  UNSELECT_ALL_HOSTINFO_ID_LIST: 'UNSELECT_ALL_HOSTINFO_ID_LIST',

  ADD_XPRESS_TEMPLATE_LIST: 'ADD_XPRESS_TEMPLATE_LIST',

  ADD_G2_CONVERT_HISTORY_LIST: 'ADD_G2_CONVERT_HISTORY_LIST',

  ADD_ORG_TO_ORG_HISTORY_LIST: 'ADD_ORG_TO_ORG_HISTORY_LIST',

  ADD_QUEUE_ACTION_DATA: 'ADD_QUEUE_ACTION_DATA',
  ADD_QUEUE_ACTION_LOG: 'ADD_QUEUE_ACTION_LOG',

  SET_KVS: 'SET_KVS',

  UPDATE_LAST_ACCESSED_KIOSK: 'UPDATE_LAST_ACCESSED_KIOSK',
};

export const SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const KIOSK_TAG = {
  NO_TAG: '',
  PROD_TEST: 'prod-test',
  CHECK_BEFORE_UPDATE: 'check-before-update',
  TEMP_BETA: 'temp-beta',
  EARLY_UPDATE: 'early-update',
  DO_NOT_UPDATE: 'do-not-update',
};

export const DEFAULT_FILTER_OPTION_TAG = '-Filter By Tag-';
export const DEFAULT_FILTER_OPTION_DEPLOYMENTSET_DESIRED = '-Filter By Deployment Set (desired)-';
export const DEFAULT_FILTER_OPTION_DEPLOYMENTSET_ACTUAL = '-Filter By Deployment Set (actual)-';
export const DEFAULT_FILTER_OPTION_ORGNAME = '-Filter By Org-';
export const DEFAULT_FILTER_OPTION_OS = '-Filter by OS-';
export const DEFAULT_FILTER_OPTION_LOCNAME = '-Filter By Location-';
export const DEFAULT_FILTER_OPTION_ACTIVE = '-Filter By Active-';

export const DEFAULT_FILTER_OPTION_SERVICE_PRINTAPI = '-Filter By printapi Running-';
export const DEFAULT_FILTER_OPTION_SERVICE_PAYAPI = '-Filter By payapi Running-';
export const DEFAULT_FILTER_OPTION_SERVICE_CAPUI = '-Filter By capui Running-';
export const DEFAULT_FILTER_OPTION_SERVICE_KIOSKPROBE = '-Filter By kiosk-probe Running-';
export const DEFAULT_FILTER_OPTION_SERVICE_KSKAPI = '-Filter By kskapi Running-';
export const DEFAULT_FILTER_OPTION_SERVICE_CAFEAPI = '-Filter By cafeapi Running-';
export const DEFAULT_FILTER_OPTION_SERVICE_HEATWAVE = '-Filter By heatwave Running-';
export const DEFAULT_FILTER_OPTION_SERVICE_CORTEX = '-Filter By cortexAgent Running-';
export const DEFAULT_FILTER_OPTION_STATUS = '-Filter By Status-';

// Also see Constant.java in dashapi
export const AUTH_TYPE_RT = 'rt';
export const AUTH_TYPE_V5 = 'v5';
export const AUTH_TYPE_AWS_OREGON = 'aws-oregon';
export const AUTH_TYPE_AWS_OHIO = 'aws-ohio';
// HE Colo - Hurricane Electric Colocation
export const AUTH_TYPE_HE_COLO_SVR = 'he-colo';
export const AUTH_TYPE_HE_COLO_DB_SVR = 'he-colo-db';
export const AUTH_TYPE_HE_COLO_TEST_SVR = 'he-colo-test';
export const AUTH_TYPE_CA_OFFICE_SVR = 'ca-office';



// WEBPACK FOOTER //
// ./src/Constants.js